import AccountManageAgencyUsers from './AccountManageAgencyUsers.vue';
const ACCOUNT_MANAGE_AGENCY_USERS_MODULE = 'manageUsers';

export default {
  id: ACCOUNT_MANAGE_AGENCY_USERS_MODULE,
  priority: 11,
  title: 'Users & Permissions',
  icon: 'people',
  component: AccountManageAgencyUsers,
  isAvailable: accountType => accountType === 'TRAVEL_AGENCY',
}

export {
  ACCOUNT_MANAGE_AGENCY_USERS_MODULE
};
